export const apiField = 's5_or_sci';


function makeConfig(data: object[]) {
  return {
    type: 'Select',
    label: 's5AttachmentPreference',
    missing: undefined,
    tooltip: undefined,
    apiField,
    data,
  };
}


const AttachmentPreference = [
    {
      value : 'S_5',
      name  : 'S-5!',
    },
    {
      value : 'SCI',
      name  : 'SCI',
    },
  ]


export default makeConfig(AttachmentPreference);
